import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {EnvironmentService} from "./core/api/environment.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'web-application';

  private readonly _showBanner

  constructor(environmentService: EnvironmentService, @Inject(DOCUMENT) document: Document) {
    this._showBanner = environmentService.isProduction.then(result => !result);
    // body.test-env (styles.scss) makes room for the fixed banner above the fixed navbar
    this._showBanner.then(show => document.body.classList.toggle('test-env', show));
  }

  get showBanner() {
    return this._showBanner
  }
}
